import { Box, Flex, Tab, TabList, Tabs, Text } from '@chakra-ui/react';
import {
  BackofficeGetPromoCounterAdminQuery,
  BackofficePromoCustomerType,
} from '@diamond/shared/types';
import { Breadcrumbs } from '@diamond/shared/ui';
import { AdminLayout } from '@diamond/sol-admin/components';
import { Link } from 'react-router-dom';

import { usePromoCounter } from '../../api/get-promo-counter';

type PromoSectionLayoutProps = {
  section: 'food-service' | 'mitra-diamond' | 'gabungan';
  children: React.ReactNode;
  extra?: React.ReactNode;
  activeFilters?: BackofficeGetPromoCounterAdminQuery;
};

const tabs = [
  {
    id: 'food-service',
    name: ' Food Service',
    title: 'Food Service',
    href: '/promo/food-service',
    customerType: 'food-service' as BackofficePromoCustomerType,
  },
  {
    id: 'mitra-diamond',
    name: ' Mitra Diamond',
    title: 'Promo  Mitra Diamond',
    href: '/promo/mitra-diamond',
    customerType: 'mitra' as BackofficePromoCustomerType,
  },
  {
    id: 'gabungan',
    name: 'Gabungan',
    title: 'Promo Gabungan',
    href: '/promo/gabungan',
    customerType: 'combination' as BackofficePromoCustomerType,
  },
];

export function PromoSectionLayout({
  section,
  extra,
  children,
  activeFilters,
}: PromoSectionLayoutProps) {
  const { data: promoCounter } = usePromoCounter(activeFilters);

  const links = [
    {
      title: 'Beranda',
      link: '/',
    },
    {
      title: 'Promo Management',
      link: '/promo',
    },
    tabs.find((t) => t.id === section) || {},
  ];

  // Define the counter map outside the loop for better readability
  // and ensure keys match BackofficePromoCustomerType
  // Let TypeScript infer the type
  const counterMap = promoCounter
    ? {
        'food-service': promoCounter.food_service,
        mitra: promoCounter.mitra,
        combination: promoCounter.combination,
      }
    : {};

  return (
    <AdminLayout>
      <Box pb="4">
        <Breadcrumbs links={links} useRouterDom />
      </Box>
      <Flex justifyContent="space-between" alignItems="center" h="40px">
        <Text fontSize="2xl" fontWeight="bold" mb="0">
          Promo Management
        </Text>
        {extra}
      </Flex>
      <Tabs
        index={Math.max(
          tabs.findIndex((t) => t.id === section),
          0
        )}
      >
        <TabList>
          {tabs.map((t) => {
            // Directly access the count from the pre-defined map
            // Use non-null assertion as customerType is guaranteed here
            const count =
              counterMap[t.customerType as keyof typeof counterMap] ?? 0;

            return (
              <Tab
                key={t.id}
                as={Link}
                to={t.href}
                _selected={{
                  color: 'blue',
                  borderColor: 'blue',
                }}
              >
                {t.name}
                {/* Conditionally render the count only if promoCounter exists */}
                {promoCounter && (
                  <Text as="span" ml="2">
                    ({count})
                  </Text>
                )}
              </Tab>
            );
          })}
        </TabList>
      </Tabs>
      <Box mt="6">{children}</Box>
    </AdminLayout>
  );
}
